import React from "react";

const ClearBtn = (props) => {
  const {
    machine_name,
    formApi,
    // children,
    clearBtn,
    isInlineModal,
    // ...rest
  } = props;
  const { clearSchema, clearFiles, conditionalClearSchema } = clearBtn;
  const clearStyle = {
    borderBottom: "1px solid",
    marginLeft: "5px",
    lineHeight: "17px",
    display: "inline-block",
    cursor: "pointer",
  };
  const handleClick = () => {
    // clear files
    const values = formApi.getState().values;
    const hasFiles =
      values &&
      values["files"] &&
      Array.isArray(values["files"]) &&
      values["files"].length > 0;
    if (hasFiles) {
      const updatedFiles = values["files"].filter(
        (file) => !clearFiles?.includes(file.machine_name)
      );
      formApi.change("files", updatedFiles);
    }

    // clear fields
    if (isInlineModal) {
      const newValues = { ...formApi.getState().values.add_values_field[0] };
      newValues[machine_name] = null;
      formApi.change("add_values_field", [newValues]);
    } else {
      formApi.change(machine_name, null);
      clearSchema.forEach((c) => {
        formApi.change(c, null);
      });
      if (!!conditionalClearSchema) {
        conditionalClearSchema.forEach((schema) => {
          const { clear, when, is } = schema;
          if (formApi.getState().values[when] === is) {
            formApi.change(clear, null);
          }
        });
      }
    }
  };
  let value = isInlineModal
    ? formApi.getState().values &&
      formApi.getState().values.add_values_field?.[0]?.[machine_name]
    : formApi.getState().values && formApi.getState().values[machine_name];

  return value ? (
    <a className="usa-link" style={clearStyle} onClick={handleClick}>
      Clear
    </a>
  ) : null;
};

export default ClearBtn;
